<script>
export default {
	methods: {
		async resizeImage(file, maxWidth, maxHeight) {
			return new Promise(resolve => {
				const image = new Image();
				image.onload = () => {
					const canvas = document.createElement('canvas');
					const ctx = canvas.getContext('2d');

					let { width, height } = image;
					let newWidth = width;
					let newHeight = height;

					if (width > height && width > maxWidth) {
						newWidth = maxWidth;
						newHeight = (maxWidth / width) * height;
					} else if (height > maxHeight) {
						newHeight = maxHeight;
						newWidth = (maxHeight / height) * width;
					}

					canvas.width = newWidth;
					canvas.height = newHeight;
					ctx.drawImage(image, 0, 0, newWidth, newHeight);

					canvas.toBlob(blob => {
						const resizedFile = new File([blob], file.name, {
							type: file.type,
							lastModified: Date.now()
						});
						resolve(resizedFile);
					}, file.type);
				};
				image.src = URL.createObjectURL(file);
			});
		}
	}
};
</script>
